var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<script src=\"//app-ab14.marketo.com/js/forms2/js/forms2.min.js\"></script><script>MktoForms2.loadForm(\"//app-ab14.marketo.com\", \"609-FDY-207\", 1230);</script><div class=\"articles-insights-marketo-form\"><form id=\"mktoForm_1230\"></form></div><div class=\"cta-bar-defer\"><a href=\"#\" class=\"icon-close\"></a></div>");;return buf.join("");
};
module.exports = template;